__turbopack_context__.v({
  "container": "LiveEventPanelInfo-module-scss-module__7frwGW__container",
  "content": "LiveEventPanelInfo-module-scss-module__7frwGW__content",
  "ctaButtonWrapper": "LiveEventPanelInfo-module-scss-module__7frwGW__ctaButtonWrapper",
  "date": "LiveEventPanelInfo-module-scss-module__7frwGW__date",
  "detailsLoadingSkeleton": "LiveEventPanelInfo-module-scss-module__7frwGW__detailsLoadingSkeleton",
  "feeInformation": "LiveEventPanelInfo-module-scss-module__7frwGW__feeInformation",
  "headline": "LiveEventPanelInfo-module-scss-module__7frwGW__headline",
  "hidden": "LiveEventPanelInfo-module-scss-module__7frwGW__hidden",
  "infoIcon": "LiveEventPanelInfo-module-scss-module__7frwGW__infoIcon",
  "visible": "LiveEventPanelInfo-module-scss-module__7frwGW__visible",
});
